export type DemoQuestion = {
    id: number
    type: "reading" | "math"
    domain: string
    difficulty: "Easy" | "Medium" | "Hard"
    text: string
    options: string[]
    correctAnswer: number // 0-3
}

export const DEMO_QUESTIONS: DemoQuestion[] = [
    {
        id: 1,
        type: "reading",
        domain: "Vocabulary",
        difficulty: "Hard",
        text: "While the research findings were initially __________, subsequent experiments clarified the mechanism, leading to a consensus among the scientific community.",
        options: ["ambiguous", "definitive", "irrelevant", "unprecedented"],
        correctAnswer: 0
    },
    {
        id: 2,
        type: "math",
        domain: "Algebra",
        difficulty: "Medium",
        text: "If 3x + 12 = 24, what is the value of x + 4?",
        options: ["4", "8", "6", "12"],
        correctAnswer: 1
    },
    {
        id: 3,
        type: "reading",
        domain: "Craft & Structure",
        difficulty: "Medium",
        text: "Which choice best describes the function of the second sentence in the overall structure of the text?",
        options: [
            "It presents a claim that is refuted in the next sentence.",
            "It provides a specific example to support the general statement made in the first sentence.",
            "It explains the methodology used in the study mentioned previously.",
            "It introduces a new perspective that contradicts the main argument."
        ],
        correctAnswer: 1
    },
    {
        id: 4,
        type: "math",
        domain: "Advanced Math",
        difficulty: "Hard",
        text: "For the function f(x) = ax² + bx + c, the vertex of the parabola is at (2, 4) and passes through the point (0, 0). What is the value of f(4)?",
        options: ["0", "4", "8", "16"],
        correctAnswer: 0
    },
    {
        id: 5,
        type: "reading",
        domain: "Standard English Conventions",
        difficulty: "Easy",
        text: "The library, which was built in 1902, _______ a vast collection of rare manuscripts.",
        options: ["house", "houses", "housing", "to house"],
        correctAnswer: 1
    },
    {
        id: 6,
        type: "math",
        domain: "Problem Solving & Data Analysis",
        difficulty: "Medium",
        text: "A car travels at an average speed of 60 miles per hour for 3 hours and then at 40 miles per hour for 2 hours. What is the average speed of the car for the entire trip?",
        options: ["50 mph", "52 mph", "48 mph", "55 mph"],
        correctAnswer: 1
    },
    {
        id: 7,
        type: "reading",
        domain: "Information & Ideas",
        difficulty: "Hard",
        text: "Based on the text, what can reasonably be inferred about the author's attitude toward the subject?",
        options: [
            "Skeptical and dismissive",
            "Cautiously optimistic",
            "Indifferent and detached",
            "Enthusiastic but naive"
        ],
        correctAnswer: 1
    },
    {
        id: 8,
        type: "math",
        domain: "Geometry and Trigonometry",
        difficulty: "Medium",
        text: "In a right triangle, one angle measures 30°. If the hypotenuse is 10 units long, what is the length of the shortest side?",
        options: ["5", "5√3", "10", "10√3"],
        correctAnswer: 0
    },
    {
        id: 9,
        type: "reading",
        domain: "Expression of Ideas",
        difficulty: "Medium",
        text: "Which choice completes the text with the most logical and precise word or phrase?",
        options: ["However,", "Therefore,", "Furthermore,", "In contrast,"],
        correctAnswer: 1
    },
    {
        id: 10,
        type: "math",
        domain: "Algebra",
        difficulty: "Hard",
        text: "What is the solution set to the inequality |2x - 5| < 7?",
        options: [
            "-1 < x < 6",
            "x < -1 or x > 6",
            "x < 6",
            "x > -1"
        ],
        correctAnswer: 0
    }
]
